import { layouts, colors, font, devices } from '../../config/theme'
import { flexStart, hidden, asPx, alignCenter } from '../../utils/jss-utils'

const style = {}

style.base = {
  ...flexStart,
  ...alignCenter,
  width: '100%',
  transition: 'all .35s',
  minHeight: asPx(layouts.footer.height),
  backgroundColor: colors.white
}

style.content = {
  '& a': {
    textDecoration: 'none',
    color: colors.black,
    fontSize: font.sizes.small
  }
}

style.copyright = {
  color: colors.lightGray,
  fontSize: '13px',
  paddingTop: '7px'
}

style.base[devices.mobile] = {
  maxWidth: '100vw',
  minWidth: '100vw',
  position: 'absolute',
  paddingLeft: '25px',
  paddingRight: '25px',
  left: 0,
  bottom: 0,
  minHeight: asPx(layouts.mobileFooter.height),
  boxShadow: `0px -1px 3px ${colors.lighterGray}`
}

style.base[devices.desktop] = {
  paddingLeft: '40px',
  paddingRight: '40px'
}

style.hideOnMobile = {}
style.hideOnMobile[devices.mobile] = { ...hidden }

export default style
